import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { Preferences } from "@capacitor/preferences";

export const LANGUAGE_STORAGE_NAME = "language-storage";

interface LanguageState {
  language: string | null;
  deviceLanguageDetected: boolean;
  setLanguage: (language: string) => void;
  setDeviceLanguageDetected: (detected: boolean) => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useLanguageStore = create<LanguageState>()(
  devtools(
    persist(
      (set) => ({
        language: null,
        deviceLanguageDetected: false,
        setLanguage: (language: string) => set({ language }),
        setDeviceLanguageDetected: (detected: boolean) => 
          set({ deviceLanguageDetected: detected }),
        reset: () => {
          set({
            language: null,
            deviceLanguageDetected: false,
          });
        },
      }),
      {
        name: LANGUAGE_STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useLanguageStore;